/* ============================================================
   MOBILE CART SHEET - LANDING PAGES ONLY
   ------------------------------------------------------------
   Self-contained. No Liquid or CSS changes needed. Returns
   immediately on /products/ URLs, so /products/custom-bundle is
   untouched by design.

   THE BUG
   .d4-flavor-bundle is position:sticky, which can never be
   painted outside its parent .d4-flavor-container. On the
   product template every other section is disabled, so the
   bundle IS the page and there is always room. On landing pages
   (land2, advertorial-1) there are sections above and below it,
   so the sheet runs out of parent, sticky bottom-aligns it, and
   its top goes negative - putting the header and close button
   above the viewport, with body{overflow:hidden} blocking any
   scroll back to reach it.

   THE FIX
   Pin the sheet to the bottom of the viewport and size the list
   with the product page's own formula, supplying the chrome
   constant it can no longer measure (landing pages hide the
   announcement bar + header, so it measures 0):
       body = innerHeight - 104 - 170
   The sheet is given no height, so it grows naturally from
   header + body + checkout, exactly as on the product page.
   Width matches the grey flavour container so it stays inset.

   SMOOTHNESS
   Sheets are pinned at page load while still display:none, so
   they are already in position when opened - no paint in the old
   sticky spot followed by a visible jump. A MutationObserver
   re-applies on open; its callback runs as a microtask, before
   the browser paints.

   DELIBERATELY NOT DONE - all tried, all made things worse:
   no clamping to the flavour section, no scrolling the page on
   open, no moving the element in the DOM, no interval polling,
   no body scroll-lock.
   ============================================================ */
(function () {
  /* --- tuning ---------------------------------------------- */
  var CHROME  = 104;  // announcement bar + header on the product page
  var RESERVE = 170;  // the theme's own constant in the same formula
  var BREAK   = 768;
  /* --------------------------------------------------------- */

  if (/\/products\//.test(window.location.pathname)) return;

  function isOpen(el) {
    if (!el) return false;
    /* Do NOT use offsetParent - it is null for any position:fixed
       element, so once pinned the sheet would read as closed and
       flip states repeatedly. */
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return false;
    var r = el.getBoundingClientRect();
    return r.height > 80 && r.width > 0;
  }

  function pin(sheet) {
    // Match the grey flavour container's horizontal bounds so the
    // sheet stays inset rather than running edge to edge.
    var ref = document.querySelector('.d4-flavor-products-container')
           || document.querySelector('.d4-flavor-container');
    var box   = ref ? ref.getBoundingClientRect() : null;
    var left  = box ? Math.round(box.left)  : 0;
    var width = box ? Math.round(box.width) : window.innerWidth;

    var s = sheet.style;
    s.setProperty('position', 'fixed', 'important');
    s.setProperty('top', 'auto', 'important');
    s.setProperty('bottom', '0px', 'important');
    s.setProperty('left', left + 'px', 'important');
    s.setProperty('right', 'auto', 'important');
    s.setProperty('width', width + 'px', 'important');
    s.setProperty('max-width', width + 'px', 'important');
    s.setProperty('margin', '0px', 'important');
    s.setProperty('height', 'auto', 'important');
    s.setProperty('max-height', 'none', 'important');
    s.setProperty('z-index', '2147483000', 'important');

    var body = sheet.querySelector('.d4-flavor-bundle-body');
    if (body) {
      var h = Math.max(180, window.innerHeight - CHROME - RESERVE);
      body.style.setProperty('min-height', h + 'px', 'important');
      body.style.setProperty('max-height', h + 'px', 'important');
      body.style.setProperty('overflow-y', 'auto', 'important');
      body.style.setProperty('-webkit-overflow-scrolling', 'touch');
      body.style.setProperty('overscroll-behavior', 'contain');
    }
  }

  function unpin(sheet) {
    var body = sheet.querySelector('.d4-flavor-bundle-body');
    if (body) body.removeAttribute('style');
    sheet.removeAttribute('style');
  }

  /* Pre-position while still display:none, so the sheet is already
     pinned the moment it becomes visible. */
  function prime() {
    if (window.innerWidth > BREAK) return false;
    var sheets = document.querySelectorAll('.d4-flavor-bundle');
    if (!sheets.length) return false;
    for (var i = 0; i < sheets.length; i++) pin(sheets[i]);
    return true;
  }

  function watch() {
    var sheets = document.querySelectorAll('.d4-flavor-bundle');
    for (var i = 0; i < sheets.length; i++) {
      (function (sheet) {
        if (sheet.__d4watched) return;
        sheet.__d4watched = true;
        new MutationObserver(function () {
          if (window.innerWidth <= BREAK && isOpen(sheet)) pin(sheet);
        }).observe(sheet, { attributes: true, attributeFilter: ['class', 'style'] });
      })(sheets[i]);
    }
  }

  function boot() {
    var ok = prime();
    watch();
    if (!ok) {
      var n = 0;
      var t = setInterval(function () {
        if (prime()) { watch(); clearInterval(t); }
        else if (++n > 40) clearInterval(t);
      }, 200);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.addEventListener('resize', function () {
    var sheets = document.querySelectorAll('.d4-flavor-bundle');
    for (var i = 0; i < sheets.length; i++) {
      if (window.innerWidth > BREAK) unpin(sheets[i]);
      else pin(sheets[i]);
    }
  }, { passive: true });
})();

document.addEventListener('DOMContentLoaded', () => {
    var d4SavedItems = d4SavedItems || [];
    var bundleFlavors, freeProducts;
    let freeProductFunctionCalled = false;
    let d4IsCheckingOut = false; // Flag to block auto-remove during checkout
    const bundleContainer = document.querySelector('.d4-custom-bundle-container');
    const fullBoxMsg = document.querySelector('.d4-custom-bundle-container').dataset.boxFull;
    const mainBundle = document.querySelector('.d4-custom-bundle-container .d4-bundle-flavors .d4-flavor-bundle .d4-flavor-bundle-body');
    const mainBundleEmpty = document.querySelector('.d4-custom-bundle-container .d4-bundle-flavors .d4-flavor-bundle .d4-flavor-bundle-body .d4-flavor-bundle-empty');
    const mobileBundle = document.querySelector('.d4-custom-bundle-container .d4-flavor-container .d4-flavor-bundle');
    const mobileBtn = document.querySelector('.d4-custom-bundle-container .d4-flavor-container .d4-bundle-mobile .d4-bundle-mobile-btn');
    const mobileBtnLabel = mobileBtn.querySelector('h3');
    const mobileBtnQuantity = mobileBtn.querySelector('span');
    const mobileCloseBtn = document.querySelector('.d4-custom-bundle-container .d4-flavor-container .d4-flavor-bundle .d4-flavor-bundle-header .d4-flavor-bundle-mobile-close');
    const checkoutBtn = mainBundle.closest('.d4-flavor-bundle').querySelector('.d4-flavor-bundle-checkout button');
    const checkoutBtnLabel= checkoutBtn.querySelector('h3');
    const checkoutBtnLabelText = checkoutBtn.querySelector('h3').dataset.stickyLabel;
    const checkoutBtnLabelText24 = checkoutBtn.querySelector('h3').dataset.stickyLabel24;
    const checkoutBtnLabelText16 = checkoutBtn.querySelector('h3').dataset.stickyLabel16;
    const checkoutBtnLabelMin = checkoutBtn.querySelector('h3').dataset.stickyMin;
    const checkoutBtnLabelReq = checkoutBtn.querySelector('h3').dataset.stickyRequired;
    const checkoutBtnLabelCp3 = checkoutBtn.querySelector('h3').dataset.stickyCp3 || 'Review Your Box';
    const checkoutBtnLabelBetweenCp2Cp3 = checkoutBtn.querySelector('h3').dataset.stickyBetweenCp2Cp3 || 'Almost there!';
    const checkoutBtnQuantity = checkoutBtn.querySelector('span');

    //Helper: render struck regular + final sale price per bundled row (qty-aware, single line)
    const d4FormatMoney = (amount, symbol) => symbol + (Math.round(amount * 100) / 100).toFixed(2);
    const d4UpdateBundledRowPrice = (row) => {
        if(!row || !bundleContainer) return;
        const regular = parseFloat(bundleContainer.dataset.unitRegular) || 0;
        const sale = parseFloat(bundleContainer.dataset.unitSale) || 0;
        const symbol = bundleContainer.dataset.unitCurrency || '$';
        const link = row.querySelector('.d4-flavor-bundled-info-link');
        if(!link) return;
        // Respect the show/hide toggle from section settings
        const show = bundleContainer.dataset.unitShow !== 'false';
        if(!show) {
            const existing = link.querySelector('.d4-bundled-price');
            if(existing) existing.remove();
            return;
        }
        // If no prices configured, do nothing
        if(regular <= 0 && sale <= 0) return;
        const qtySpan = row.querySelector('.d4-flavor-product-quantity span');
        const qty = Number(qtySpan ? qtySpan.textContent : 1) || 1;
        let priceEl = link.querySelector('.d4-bundled-price');
        if(!priceEl) {
            priceEl = document.createElement('div');
            priceEl.classList.add('d4-bundled-price');
            const compare = document.createElement('span');
            compare.classList.add('d4-bundled-price-compare');
            const final = document.createElement('span');
            final.classList.add('d4-bundled-price-sale');
            priceEl.appendChild(compare);
            priceEl.appendChild(final);
            // Place the price under the flavour name, above the Remove Item link
            const removeBtn = link.querySelector('button');
            if(removeBtn) { link.insertBefore(priceEl, removeBtn); }
            else { link.appendChild(priceEl); }
        }
        const compareEl = priceEl.querySelector('.d4-bundled-price-compare');
        const saleEl = priceEl.querySelector('.d4-bundled-price-sale');
        // Show struck regular only when it's higher than the sale price
        if(regular > sale && regular > 0) {
            compareEl.textContent = d4FormatMoney(regular * qty, symbol);
            compareEl.style.display = '';
        } else {
            compareEl.style.display = 'none';
        }
        saleEl.textContent = d4FormatMoney((sale > 0 ? sale : regular) * qty, symbol);
    };

    //Helper: live subtotal / savings / total summary above checkout
    const d4UpdateBundleSummary = () => {
        const summaryEl = document.querySelector('.d4-custom-bundle-container .d4-bundle-summary');
        if(!summaryEl || !bundleContainer) return;
        const regular = parseFloat(bundleContainer.dataset.unitRegular) || 0;
        const sale = parseFloat(bundleContainer.dataset.unitSale) || 0;
        const symbol = bundleContainer.dataset.unitCurrency || '$';
        let subtotal = 0, total = 0, pouchCount = 0;
        // Sum only paid bundled items (free products are excluded)
        mainBundle.querySelectorAll('.d4-flavor-product-bundled').forEach(row => {
            const qtySpan = row.querySelector('.d4-flavor-product-quantity span');
            const qty = Number(qtySpan ? qtySpan.textContent : 0) || 0;
            subtotal += regular * qty;
            total += sale * qty;
            pouchCount += qty;
        });
        const savings = subtotal - total;
        const subEl = summaryEl.querySelector('.d4-summary-subtotal');
        const saveEl = summaryEl.querySelector('.d4-summary-savings');
        const totEl = summaryEl.querySelector('.d4-summary-total');
        const saveRow = summaryEl.querySelector('.d4-bundle-summary-savings');
        if(subEl) subEl.textContent = d4FormatMoney(subtotal, symbol);
        if(saveEl) saveEl.textContent = '-' + d4FormatMoney(savings, symbol);
        if(totEl) totEl.textContent = d4FormatMoney(total, symbol);
        // Hide the savings row when there's no discount
        if(saveRow) saveRow.style.display = savings > 0.001 ? '' : 'none';

        // Meals badge beside total — only at checkpoint quantities (e.g. 6 / 9 / 11 pouches)
        const mealsEl = summaryEl.querySelector('.d4-summary-meals');
        if(mealsEl) {
            const mBar = document.querySelector('.d4-mobile-progress-bar');
            const cp1 = (mBar && Number(mBar.dataset.cp1)) || 6;
            const cp2 = (mBar && Number(mBar.dataset.cp2)) || 9;
            const cp3 = (mBar && Number(mBar.dataset.cp3)) || 11;
            const perPouch = parseFloat(mealsEl.dataset.mealsPer) || 4;
            const mealsWord = mealsEl.dataset.mealsLabel || 'meals';
            if(pouchCount === cp1 || pouchCount === cp2 || pouchCount === cp3) {
                mealsEl.textContent = '(' + (pouchCount * perPouch) + ' ' + mealsWord + ')';
                mealsEl.style.display = '';
            } else {
                mealsEl.style.display = 'none';
            }
        }

        // Hide the whole block when the box is empty
        if(subtotal <= 0) summaryEl.classList.add('d4-summary-hidden');
        else summaryEl.classList.remove('d4-summary-hidden');
    };

    //Function to change the active class within variants & within options
    const d4HandleBundleVariants = () => {
        const mealVariants = document.querySelectorAll('.d4-custom-bundle-container .d4-options .d4-option-btn');
        var selectedOption = localStorage.getItem('d4-option');
        if(selectedOption === null || selectedOption === undefined) {
            mealVariants[0].classList.add('d4-option-selected');
        } else {
            for(option of mealVariants) {
                if(option.dataset.d4Option === selectedOption) {
                    option.classList.add('d4-option-selected');
                } else {
                    option.classList.remove('d4-option-selected');
                }
            }
        }

        //update active class of the option meals & store the value
        for(variant of mealVariants) {
            variant.addEventListener('click', (e) => {
                mealVariants.forEach(variant => {
                    if(variant !== e.target) {
                        variant.classList.remove('d4-option-selected');
                    }
                });

                e.target.classList.add('d4-option-selected');
                localStorage.setItem('d4-option', e.target.dataset.d4Option);
            });
        };
    };


    //Function to load bundleobject
    const d4LoadbundleObject = () => {
        bundleFlavors = d4BundleObject();
        console.log('bundle object: ', bundleFlavors)
    };

    //Function to load free Products
    const d4LoadFreeProducts = () => {
        freeProducts = d4freeProducts();
        console.log('free products: ', freeProducts)
    };

    //Function to handle the filters changes
    const d4HandleFilterChanges = () => {
        const filterProducts = document.querySelectorAll('.d4-custom-bundle-container .d4-flavor-container .d4-flavor-products .d4-flavor-product');
        const filterCloseBtn = document.querySelector('.d4-custom-bundle-container .d4-flavor-heading .d4-filter-label svg');
        const filterLabel = document.querySelector('.d4-custom-bundle-container .d4-flavor-heading .d4-filter-label span');
        const filterSelect = document.querySelector('.d4-custom-bundle-container .d4-flavor-container .d4-flavor-heading select');

        //function to reset filters
        const d4ResetFilters = () => {
            for(product of filterProducts) {
                product.classList.remove('d4-hide-product');
                if(filterCloseBtn) filterCloseBtn.style.display = 'none';
                if(filterSelect) filterSelect.value = 'All Flavors';
                if(filterLabel) filterLabel.textContent = 'All Flavors';
            }
        }

        //remove all filters
        if(filterCloseBtn) {
            filterCloseBtn.addEventListener('click', () => {
                d4ResetFilters();
            });
        }

        //filter products on changing values
        if(filterSelect) {
            filterSelect.addEventListener('change', (e) => {
                for(product of filterProducts) {
                    if(e.target.value === 'All Flavors') {
                        d4ResetFilters();
                    } else {
                        const target = e.target.value.toLowerCase().split(' ').join('-');
                        if(!product.dataset.filter || !product.dataset.filter.includes(target)) {
                            product.classList.add('d4-hide-product');
                        } else {
                            product.classList.remove('d4-hide-product');
                        }
                        if(filterCloseBtn) filterCloseBtn.style.display = 'block';
                        if(filterLabel) filterLabel.textContent = e.target.value;
                    }
                }
            })
        }
    }


    //Function to add free product
    if(bundleContainer.hasAttribute('data-d4-bundle-free-product')) {
        var d4HandleFreeProduct = () => {
            console.log('free product function called')
            for(product of freeProducts) {
            const elm = document.createElement('div');
            elm.classList.add('d4-free-product-bundled');
            elm.setAttribute('data-bundled-id', product.id);
            const img = document.createElement('img');
            img.classList.add('d4-flavor-prdouct-img');
            img.setAttribute('src', product.img);
            elm.appendChild(img);
            const info = document.createElement('div');
            info.classList.add('d4-free-product-info');
            const title = document.createElement('h3');
            const text = document.createElement('h3');
            title.textContent = product.title;
            text.textContent = 'Free With Your First Order';
            info.appendChild(title);
            info.appendChild(text);
            /* Price with compare/scratch price */
            if(product.price) {
                // Struck value (compare-at if set, else the product price) followed by FREE, like the pouch rows
                const priceWrap = document.createElement('div');
                priceWrap.classList.add('d4-free-product-prices');
                const struck = (product.compare_price && product.compare_price !== product.price) ? product.compare_price : product.price;
                const isZero = /^[^0-9]*0(?:[.,]00?)?[^0-9]*$/.test(struck || '');
                if(struck && !isZero) {
                    const comparePrice = document.createElement('span');
                    comparePrice.classList.add('d4-free-product-compare-price');
                    comparePrice.textContent = struck;
                    priceWrap.appendChild(comparePrice);
                }
                const currentPrice = document.createElement('span');
                currentPrice.classList.add('d4-free-product-price');
                currentPrice.textContent = 'FREE';
                priceWrap.appendChild(currentPrice);
                info.appendChild(priceWrap);
            }
            elm.appendChild(info);
            const freetagdiv = document.createElement('div');
            freetagdiv.classList.add('d4-bundle-free-tag');
            const freetag = document.createElement('h4');
            freetag.textContent = 'FREE';
            freetag.classList.add('d4-bundle-free-tag');
            freetagdiv.appendChild(freetag);
            elm.appendChild(freetagdiv);
            mainBundle.appendChild(elm);
            console.log(elm, mainBundle)
            }
        };
    }


    //Function to Handle main bundle functionality
    window.d4HandleBundle = function() {
        const productAddBtns = document.querySelectorAll('.d4-custom-bundle-container .d4-flavor-container .d4-flavor-products .d4-flavor-product .d4-flavor-product-btn');
        //const mainBundle = document.querySelector('.d4-custom-bundle-container .d4-bundle-flavors .d4-flavor-bundle .d4-flavor-bundle-body');

        for(btn of productAddBtns) {
            btn.addEventListener('click', (e) => {
                d4UpdateBundle(e.target.closest('.d4-flavor-product'));
            })
        }

        //check local storage key exists
        if(localStorage.getItem('d4SavedItems')?.length > 2) {
            const savedItems = localStorage.getItem('d4SavedItems');
            const savedItemsArray = JSON.parse(savedItems);
            // A saved item can point at a product this page renders differently:
            // VIP-locked flavours have a .d4-vip-btn instead of .d4-flavor-product-btn,
            // and sold-out ones have .d6-outofStock. Reading .classList off that null
            // button threw, which aborted the rest of d4HandleBundle() - so
            // window.d4UpdateBundle never got defined and the entire widget went dead.
            //
            // These rows are now kept. The customer picked them on the VIP page, so
            // silently deleting a pouch (and quietly dropping them under a free
            // shipping threshold) is worse than letting the row stand. The bundle row's
            // own +/- and Remove all work. Only the grid card stays locked, so once a
            // flavour is removed entirely they have to go back to the VIP page for it.
            let d4RestoreChanged = false;
            savedItemsArray.forEach(item => {
                const { outerhtml } = item;
                const html = new DOMParser().parseFromString(outerhtml, 'text/html');
                const elm = html.body.firstChild;
                if (!elm || !elm.dataset) { d4RestoreChanged = true; return; }

                const filterProduct = document.querySelector(`.d4-custom-bundle-container .d4-flavor-container .d4-flavor-products .d4-flavor-product[data-product-id="${elm.dataset.bundledId}"]`);

                // Product isn't on this page at all - nothing to sync against, so drop it.
                if (!filterProduct) { d4RestoreChanged = true; return; }

                mainBundle.appendChild(elm);
                d4HandleBundleProduct(elm);
                d4UpdateBundledRowPrice(elm);
                d4SaveBundleProducts(elm, null);

                const quantity = filterProduct.querySelector('.d4-flavor-product-quantity');
                const btn      = filterProduct.querySelector('.d4-flavor-product-btn');
                const span     = quantity ? quantity.querySelector('span') : null;
                const srcSpan  = elm.querySelector('.d4-flavor-product-quantity span');

                if (span && srcSpan) span.textContent = srcSpan.textContent;

                if (btn) {
                    // Normal flavour: swap the grid card into its selected state.
                    if (quantity) quantity.classList.remove('d4-flavor-hidden');
                    btn.classList.add('d4-flavor-hidden');
                    filterProduct.classList.add('d4-product-selected');
                }
                // No btn means VIP-locked or sold out. The grid card is left showing its
                // locked state on purpose - the bundle row is the only way to adjust it.
            })

            if (d4RestoreChanged) {
                const stillThere = [];
                document.querySelectorAll('.d4-flavor-product-bundled[data-bundled-id]').forEach(row => {
                    stillThere.push(row.dataset.bundledId);
                });
                try {
                    localStorage.setItem('d4SavedItems', JSON.stringify(
                        savedItemsArray.filter(it => {
                            const h = new DOMParser().parseFromString(it.outerhtml, 'text/html').body.firstChild;
                            return h && stillThere.includes(h.dataset.bundledId);
                        })
                    ));
                } catch(e){}
            }
        }

        window.d4UpdateBundle = function(elm, elmqnt) {
            const elmQuantity = elm.querySelector('.d4-flavor-product-quantity');
            const elmBtn = elm.querySelector('.d4-flavor-product-btn');
            // elmBtn is absent on VIP-locked and sold-out cards. Nothing should be
            // calling this for those, but a null here used to take the page down.
            if (elmQuantity) elmQuantity.classList.remove('d4-flavor-hidden');
            if (elmBtn) elmBtn.classList.add('d4-flavor-hidden');
            elm.classList.add('d4-product-selected');

            const newElm = document.createElement('div');
            const newElmInfo = document.createElement('div');
            const newElmInfoLink = document.createElement('div');
            const newElmInfoBtn = document.createElement('button');
            newElmInfoBtn.textContent = 'Remove Item';
            newElm.setAttribute('data-bundled-id', elm.dataset.productId);
            newElm.classList.add('d4-flavor-product-bundled');
            newElmInfo.classList.add('d4-flavor-bundled-info');
            newElmInfoLink.classList.add('d4-flavor-bundled-info-link');
            const img = elm.querySelector('.d4-flavor-prdouct-img').cloneNode(true);
            const name = elm.querySelector('.d4-flavor-product-info h3').cloneNode(true);
            const quantity = elm.querySelector('.d4-flavor-product-quantity').cloneNode(true);
            if(elmqnt !== null && elmqnt !== undefined) {
                quantity.querySelector('span').textContent = elmqnt;
                elm.querySelector('.d4-flavor-product-quantity span').textContent = elmqnt;
            }
            quantity.querySelectorAll('button').forEach(button => {
                button.setAttribute('data-bundle-quantity', 'true');
            });
            //adding new product to the sticky bundle
            newElm.appendChild(img);
            newElm.appendChild(newElmInfo);
            newElmInfo.appendChild(newElmInfoLink);
            newElmInfoLink.appendChild(name);
            newElmInfoLink.appendChild(newElmInfoBtn);
            newElmInfo.appendChild(quantity);
            mainBundle.appendChild(newElm);
            d4HandleBundleProduct(newElm);
            d4UpdateBundledRowPrice(newElm);
            d4SaveBundleProducts(newElm, null);
            d4HandleProgress();
        };
    };

    //Function to handle quantity changes & add/remove product into bundle
    const d4HandleBundleProduct = (elm) => {
        let filterProduct = document.querySelector(`.d4-custom-bundle-container .d4-flavor-container .d4-flavor-products .d4-flavor-product[data-product-id="${elm.dataset.bundledId}"]`);
        // The matching grid card may not exist on this page at all, or may be
        // VIP-locked / sold out. Without this the remove button threw and the row
        // became impossible to take off the bundle.
        if (!filterProduct) {
            const removeBtn = elm.querySelector('.d4-flavor-bundled-info-link button');
            if (removeBtn) {
                removeBtn.addEventListener('click', () => {
                    elm.remove();
                    if (typeof d4SaveBundleProducts === 'function') d4SaveBundleProducts(elm, 'remove');
                    if (typeof d4UpdateBundleProgress === 'function') d4UpdateBundleProgress();
                });
            }
            return;
        }
        const filterProductQuantities = filterProduct.querySelectorAll('.d4-flavor-product-quantity button');
        const elmQuantities = elm.querySelectorAll('.d4-flavor-product-quantity button');
        //handle remove button click
        elm.querySelector('.d4-flavor-bundled-info-link button').addEventListener('click', d4RemoveProduct);
        //use to remove element from sticky bundle
        function d4RemoveProduct() {
            const fpBtn = filterProduct.querySelector('.d4-flavor-product-btn');
            const fpQty = filterProduct.querySelector('.d4-flavor-product-quantity');
            if (fpBtn) fpBtn.classList.remove('d4-flavor-hidden');
            if (fpQty) fpQty.classList.add('d4-flavor-hidden');
            filterProduct.classList.remove('d4-product-selected');
            const filterQuantity = filterProduct.querySelector('.d4-flavor-product-quantity span');
            //const BundledQuantity = elm.querySelector('.d4-flavor-product-quantity span');
            filterQuantity.textContent = '1';
            //BundledQuantity.textContent = '1';
            filterProductQuantities.forEach(quantity => {
                quantity.removeEventListener('click', d4HandleProductListener);
            })
            d4SaveBundleProducts(null, elm);
            elm.remove();
            d4HandleProgress();
        }

        function d4HandleProductListener(e) {
            if(e.target.classList.contains('d4-bundle-full')) {
                return
            } else {
                d4HandleBundleQuantityChange(e.target);
                d4HandleProgress();
            }
        }

        for(quantityBtn of filterProductQuantities) {
            quantityBtn.addEventListener('click', d4HandleProductListener)
        }

        for(quantityBtn of elmQuantities) {
            quantityBtn.addEventListener('click', d4HandleProductListener)
        }


        //Handle quantity update + remove product conditionaly
        function d4HandleBundleQuantityChange(btn) {
            const filterQuantity = filterProduct.querySelector('.d4-flavor-product-quantity span');
            const bundleQuantity = elm.querySelector('.d4-flavor-product-quantity span');
                if(btn.dataset.action === 'plus') {
                    filterQuantity.textContent = Number(filterQuantity.textContent) + 1;
                    bundleQuantity.textContent = Number(bundleQuantity.textContent) + 1;
                    d4UpdateBundledRowPrice(elm);
                    d4SaveBundleProducts(elm, null);
                } else {
                    if(filterQuantity.textContent === '1') {
                        d4RemoveProduct();
                    } else {
                        filterQuantity.textContent = Number(filterQuantity.textContent) - 1;
                        bundleQuantity.textContent = Number(bundleQuantity.textContent) - 1;
                        d4UpdateBundledRowPrice(elm);
                        d4SaveBundleProducts(elm, null);
                    }
                }
        }
    };


    //Function to save the last added bundle products
    const d4SaveBundleProducts = (addProduct, removeProduct) => {
        if(removeProduct === null || removeProduct === undefined) {
            const addProductIndex = d4SavedItems.indexOf(addProduct);
            if(addProductIndex !== -1 && addProductIndex !== null) {
                d4SavedItems[addProductIndex] = addProduct;
            } else {
                d4SavedItems.push(addProduct);
            }
        } else if(addProduct === null || addProduct === undefined) {
            const removeProductIndex = d4SavedItems.indexOf(removeProduct);
            if(removeProductIndex !== -1) {
                d4SavedItems.splice(removeProductIndex, 1);
            }
        }

        const d4SavedItemsArray = [];
        d4SavedItems.forEach(item => {
            d4SavedItemsArray.push({outerhtml: item.outerHTML})
        })
        const d4SavedItemsJson = JSON.stringify(d4SavedItemsArray);
        localStorage.setItem('d4SavedItems', d4SavedItemsJson);
    };




    //Function to handle progress bar and checkout (3-checkpoint version)
    const d4HandleProgress = () => {
        const progressBar = document.querySelector('.d4-custom-bundle-container .d4-bundle-body .d4-flavor-bundle .d4-flavor-bundle-bar');

        // Calculate totalLength first (needed for both desktop and mobile)
        let totalLength = 0;
        const mainBundleProductsQuantity = mainBundle.querySelectorAll('.d4-flavor-product-bundled .d4-flavor-product-quantity span');
        mainBundleProductsQuantity.forEach(quantity => {
            totalLength += Number(quantity.textContent) || 0;
        });

        // Keep the subtotal / savings / total summary in sync on every change
        d4UpdateBundleSummary();

        // Sync mobile progress bar (always runs, even when desktop bar is hidden)
        const mobileBar = document.querySelector('.d4-mobile-progress-bar');
        if (mobileBar) {
            const mCp1 = Number(mobileBar.dataset.cp1) || 6;
            const mCp2 = Number(mobileBar.dataset.cp2) || 9;
            const mCp3 = Number(mobileBar.dataset.cp3) || 15;
            const mFill = mobileBar.querySelector('.d4-mobile-progress-fill');
            const mTracker = mobileBar.querySelector('.d4-mobile-cp-tracker');
            const mCp1El = mobileBar.querySelector('.d4-mobile-cp1');
            const mCp2El = mobileBar.querySelector('.d4-mobile-cp2');
            const mCp3El = mobileBar.querySelector('.d4-mobile-cp3');

            let mPct = 0;
            if (totalLength <= 0) { mPct = 0; }
            else if (totalLength <= mCp1) { mPct = (totalLength / mCp1) * 33.33; }
            else if (totalLength <= mCp2) { mPct = 33.33 + ((totalLength - mCp1) / (mCp2 - mCp1)) * 33.33; }
            else if (totalLength <= mCp3) { mPct = 66.66 + ((totalLength - mCp2) / (mCp3 - mCp2)) * 33.34; }
            else { mPct = 100; }

            if (mFill) {
                const mTrackEl = mobileBar.querySelector('.d4-mobile-progress-track');
                if (mTrackEl && mTrackEl.offsetWidth) {
                    mFill.style.width = ((mPct / 100) * mTrackEl.offsetWidth) + 'px';
                } else {
                    mFill.style.width = mPct + '%';
                }
            }
            if (mTracker) {
                mTracker.textContent = totalLength;
                mTracker.style.left = mPct + '%';
                mTracker.classList.toggle('at-zero', totalLength === 0);
            }
            if (mCp1El) { mCp1El.classList.toggle('cp-reached', totalLength >= mCp1); mCp1El.style.opacity = totalLength === mCp1 ? '0' : '1'; }
            if (mCp2El) { mCp2El.classList.toggle('cp-reached', totalLength >= mCp2); mCp2El.style.opacity = totalLength === mCp2 ? '0' : '1'; }
            if (mCp3El) { mCp3El.classList.toggle('cp-reached', totalLength >= mCp3); mCp3El.style.opacity = totalLength === mCp3 ? '0' : '1'; }
        }

        // Get max value from mobile bar data or fallback
        const globalCp1 = (mobileBar && Number(mobileBar.dataset.cp1)) || 6;
        const globalCp2 = (mobileBar && Number(mobileBar.dataset.cp2)) || 9;
        const globalCp3 = (mobileBar && Number(mobileBar.dataset.cp3)) || 15;
        const globalMax = globalCp3;

        // Update checkout btn (always runs - works on both desktop and mobile)
        if(totalLength < globalCp1) {
            // Before checkpoint 1
            checkoutBtnLabel.textContent = checkoutBtnLabelMin;
            mobileBtnLabel.textContent = checkoutBtnLabelMin;
            checkoutBtn.classList.remove('d4-flavor-checkout-ready');
            mobileBtn.classList.remove('d4-bundle-mobile-btn-ready');
            checkoutBtnQuantity.style.display = 'flex';
            mobileBtnQuantity.style.display = 'flex';
        } else if(totalLength === globalCp1) {
            // At checkpoint 1
            checkoutBtnLabel.textContent = checkoutBtnLabelText;
            mobileBtnLabel.textContent = checkoutBtnLabelText;
            checkoutBtn.classList.add('d4-flavor-checkout-ready');
            mobileBtn.classList.add('d4-bundle-mobile-btn-ready');
            checkoutBtnQuantity.style.display = 'none';
        } else if(totalLength > globalCp1 && totalLength < globalCp2) {
            // Between checkpoint 1 & 2
            checkoutBtnLabel.textContent = checkoutBtnLabelText16;
            mobileBtnLabel.textContent = checkoutBtnLabelText16;
            checkoutBtn.classList.remove('d4-flavor-checkout-ready');
            mobileBtn.classList.remove('d4-bundle-mobile-btn-ready');
            checkoutBtnQuantity.style.display = 'flex';
            mobileBtnQuantity.style.display = 'flex';
        } else if(totalLength === globalCp2) {
            // At checkpoint 2
            checkoutBtnLabel.textContent = checkoutBtnLabelText24;
            mobileBtnLabel.textContent = checkoutBtnLabelText24;
            checkoutBtn.classList.add('d4-flavor-checkout-ready');
            mobileBtn.classList.add('d4-bundle-mobile-btn-ready');
            checkoutBtnQuantity.style.display = 'none';
        } else if(totalLength > globalCp2 && totalLength < globalCp3) {
            // Between checkpoint 2 & 3
            checkoutBtnLabel.textContent = checkoutBtnLabelBetweenCp2Cp3;
            mobileBtnLabel.textContent = checkoutBtnLabelBetweenCp2Cp3;
            checkoutBtn.classList.remove('d4-flavor-checkout-ready');
            mobileBtn.classList.remove('d4-bundle-mobile-btn-ready');
            checkoutBtnQuantity.style.display = 'flex';
            mobileBtnQuantity.style.display = 'flex';
        } else if(totalLength >= globalCp3) {
            // At checkpoint 3 (max)
            checkoutBtnLabel.textContent = checkoutBtnLabelCp3;
            mobileBtnLabel.textContent = checkoutBtnLabelCp3;
            checkoutBtnQuantity.style.display = 'none';
            checkoutBtn.classList.add('d4-flavor-checkout-ready');
            mobileBtn.classList.add('d4-bundle-mobile-btn-ready');
        }
        checkoutBtnQuantity.textContent = totalLength;
        mobileBtnQuantity.textContent = totalLength;

        // Lock bundle and products when it reaches the max limit (always runs)
        const bundleAndFilterProductsInfo = document.querySelectorAll('.d4-custom-bundle-container .d4-flavor-container .d4-flavor-product,.d4-custom-bundle-container .d4-flavor-container .d4-flavor-product-bundled');
        if(totalLength >= globalMax) {
            bundleAndFilterProductsInfo.forEach(product => {
                if(product.querySelector('.d4-flavor-product-btn')) {
                    product.querySelector('.d4-flavor-product-btn').textContent = fullBoxMsg;
                    product.querySelector('.d4-flavor-product-btn').classList.add('d4-bundle-full');
                }
                product.querySelector('.d4-flavor-product-quantity button[data-action="plus"]').classList.add('d4-bundle-full');
            })
        } else {
            bundleAndFilterProductsInfo.forEach(product => {
                if(product.querySelector('.d4-flavor-product-btn')) {
                    product.querySelector('.d4-flavor-product-btn').textContent = '+ Add';
                    product.querySelector('.d4-flavor-product-btn').classList.remove('d4-bundle-full');
                }
                product.querySelector('.d4-flavor-product-quantity button[data-action="plus"]').classList.remove('d4-bundle-full');
            })
        }

        // Empty state
        if(totalLength === 0) {
            mainBundleEmpty.classList.remove('d4-flavor-bundle-hide');
            const bundledfreeProductEarly = mainBundle.querySelectorAll('.d4-free-product-bundled');
            bundledfreeProductEarly?.forEach(product => product.remove());
            freeProductFunctionCalled = false;
        } else {
            mainBundleEmpty.classList.add('d4-flavor-bundle-hide');
        }

        // Free product at checkpoint logic
        if(bundleContainer.hasAttribute('data-d4-bundle-free-product') && typeof d4HandleFreeProduct === 'function') {
            const freeCp1 = bundleContainer.dataset.freeCp1 === 'true';
            const freeCp2 = bundleContainer.dataset.freeCp2 === 'true';
            const freeCp3 = bundleContainer.dataset.freeCp3 === 'true';
            const existingFree = mainBundle.querySelector('.d4-free-product-bundled');

            // Determine if free product should show based on which checkpoints are hit
            let showFree = false;
            if(freeCp1 && totalLength >= globalCp1) showFree = true;
            if(freeCp2 && totalLength >= globalCp2) showFree = true;
            if(freeCp3 && totalLength >= globalCp3) showFree = true;
            if(totalLength === 0) showFree = false;

            if(showFree && !existingFree) {
                d4HandleFreeProduct();
                freeProductFunctionCalled = true;
            } else if(!showFree && existingFree) {
                mainBundle.querySelectorAll('.d4-free-product-bundled').forEach(p => p.remove());
                freeProductFunctionCalled = false;

                // Auto-remove free product from cart when user drops below threshold
                if(!d4IsCheckingOut && typeof freeProducts !== 'undefined' && freeProducts && freeProducts.length > 0) {
                    fetch('/cart.js')
                        .then(r => r.json())
                        .then(cart => {
                            const freeIds = freeProducts.map(p => String(p.id));
                            cart.items.forEach(item => {
                                if(freeIds.includes(String(item.variant_id))) {
                                    fetch('/cart/change.js', {
                                        method: 'POST',
                                        headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify({ id: String(item.variant_id), quantity: 0 })
                                    }).then(() => {
                                        console.log('Free product auto-removed from cart');
                                        // Trigger cart UI refresh if available
                                        document.dispatchEvent(new CustomEvent('cart:updated'));
                                    });
                                }
                            });
                        });
                }
            }
        }

        // Desktop progress bar (may be hidden on mobile)
        if (!progressBar) return;
        const progressBarWidth = progressBar.offsetWidth;
        if (!progressBarWidth) return;
        const progressBarPointerDiv = progressBar.querySelector('.d4-flavor-bundle-progress-bar');
        const progressBarPointer = progressBar.querySelector('.d4-flavor-bundle-bar-custom');
        if (!progressBarPointerDiv || !progressBarPointer) return;

        // Read 3 checkpoints from data attributes, fallback to old min/max elements
        const cp1Val = Number(progressBar.dataset.cp1) || Number((progressBar.querySelector('.d4-flavor-bundle-bar-min') || {}).textContent) || 6;
        const cp2Val = Number(progressBar.dataset.cp2) || Number((progressBar.querySelector('.d4-flavor-bundle-bar-max') || {}).textContent) || 9;
        const cp3Val = Number(progressBar.dataset.cp3) || 15;
        const maxVal = cp3Val; // The absolute max is checkpoint 3

        const cp1El = progressBar.querySelector('.d4-flavor-bundle-bar-cp1');
        const cp2El = progressBar.querySelector('.d4-flavor-bundle-bar-cp2');
        const cp3El = progressBar.querySelector('.d4-flavor-bundle-bar-cp3');

        // Desktop visual bar updates only
        if(totalLength >= cp1Val) {
            progressBarPointerDiv.classList.add('d4-progress-bar-min');
        } else {
            progressBarPointerDiv.classList.remove('d4-progress-bar-min');
        }

        let pct = 0;
        if (totalLength <= 0) { pct = 0; }
        else if (totalLength <= cp1Val) { pct = (totalLength / cp1Val) * 33.33; }
        else if (totalLength <= cp2Val) { pct = 33.33 + ((totalLength - cp1Val) / (cp2Val - cp1Val)) * 33.33; }
        else if (totalLength <= cp3Val) { pct = 66.66 + ((totalLength - cp2Val) / (cp3Val - cp2Val)) * 33.34; }
        else { pct = 100; }

        const pointerPos = (pct / 100) * progressBarWidth;
        progressBarPointer.style.left = `${pointerPos - 1}px`;
        progressBarPointerDiv.style.width = `${pointerPos + 12}px`;
        progressBarPointer.textContent = totalLength;

        if (cp1El) { cp1El.classList.toggle('cp-reached', totalLength >= cp1Val); cp1El.style.opacity = totalLength === cp1Val ? '0' : '1'; }
        if (cp2El) { cp2El.classList.toggle('cp-reached', totalLength >= cp2Val); cp2El.style.opacity = totalLength === cp2Val ? '0' : '1'; }
        if (cp3El) { cp3El.classList.toggle('cp-reached', totalLength >= cp3Val); cp3El.style.opacity = totalLength === cp3Val ? '0' : '1'; }
    };



    const d4HandleCheckout = () => {
        checkoutBtn.addEventListener('click', () => {
            if(checkoutBtn.classList.contains('d4-flavor-checkout-ready')) {
                let productIds = [];

                // Add free products only if they're currently showing in the bundle
                // (skipped below if the cart already holds one - limit 1 shaker per order)
                const currentFreeProducts = mainBundle.querySelectorAll('.d4-free-product-bundled');
                const freeIdsToAdd = [];
                if(currentFreeProducts.length > 0 && typeof freeProducts !== 'undefined' && freeProducts) {
                    for(product of freeProducts) {
                        freeIdsToAdd.push(String(product.id));
                    }
                }

                // Add bundled products
                const bundledProducts = mainBundle.querySelectorAll('.d4-flavor-product-bundled');
                for(product of bundledProducts) {
                    productIds.push({id: product.dataset.bundledId, quantity: product.querySelector('.d4-flavor-product-quantity span').textContent});
                }

                let formData = {
                    'items': productIds.map(product => ({
                      'id': product.id,
                      'quantity': product.quantity
                    }))
                };

                d4IsCheckingOut = true; // Block auto-remove during checkout

                // Limit 1 shaker per order: look at the existing cart first, only add the shaker if it isn't
                // already there, and trim any duplicate down to 1 before heading to checkout.
                const root = window.Shopify.routes.root;
                fetch(root + 'cart.js')
                .then(r => r.json())
                .catch(() => ({ items: [] }))
                .then(cart => {
                    const inCart = (cart.items || []).filter(it => freeIdsToAdd.indexOf(String(it.variant_id)) !== -1 || (typeof freeProducts !== 'undefined' && freeProducts && freeProducts.some(p => String(p.id) === String(it.variant_id))));
                    if(freeIdsToAdd.length && !inCart.length) {
                        formData.items.unshift({ id: freeIdsToAdd[0], quantity: 1 });
                    }
                    return fetch(root + 'cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(formData)
                    }).then(response => {
                        const fix = {};
                        inCart.forEach((it, i) => { if(it.quantity !== (i === 0 ? 1 : 0)) fix[it.variant_id] = (i === 0 ? 1 : 0); });
                        if(!Object.keys(fix).length) return response;
                        return fetch(root + 'cart/update.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ updates: fix })
                        }).then(() => response, () => response);
                    });
                })
                .then(response => {
                    console.log('products added')
                    d4ClearBundle();
                    mainBundle.querySelectorAll('.d4-free-product-bundled')?.forEach(product => product.remove());
                    window.location.pathname = 'cart/checkout';
                    return response.json();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
            }
        })
    };



    //Function to clear products from bundle
    const d4ClearBundle = () => {
        const bundledItems = document.querySelectorAll('.d4-custom-bundle-container .d4-bundle-flavors .d4-flavor-bundle .d4-flavor-bundle-body .d4-flavor-product-bundled');
        bundledItems.forEach(bundledItem => {
            bundledItem.querySelector('button').click();
        })
        d4SavedItems = [];
        d4HandleProgress();
    };



    //Function to handle the flavor tags and update bundle
    const d4CustomBundleObject = () => {
        let tagProductsId;
        const flavorBtns = document.querySelectorAll('.d4-custom-bundle-container .d4-flavor-tags .d4-flavor-tag');
        for(btn of flavorBtns) {
            btn.addEventListener('click', (e) => {
                mainBundle.querySelector('.d4-free-product-bundled')?.remove();
                freeProductFunctionCalled = false;
                d4HandleTagsClick(e.target.textContent);

                // Open Bundle Drawer on Mobile
                if(window.innerWidth <= 768) {
                    mobileBtn.dispatchEvent(new Event('click'));
                    const scrollDiv = document.querySelector('.d4-custom-bundle-container .d4-flavor-container').offsetTop;
                    window.scrollTo({top: scrollDiv, behavior: "smooth"});
                }
            })
        }

        //Function to collect all the products related to clicked tag
        const d4HandleTagsClick = (currentTag) => {
            tagProductsId = bundleFlavors.filter(flavor => {
               return flavor.hasOwnProperty(`${currentTag}`) 
            }).map(flavor => flavor[`${currentTag}`]);

            //get the selected option vlaue
            const selectedOption = document.querySelector('.d4-custom-bundle-container .d4-options .d4-option-selected');
            const quantityLimit = Number(selectedOption.dataset.sizeOption);
            console.log('limit:', quantityLimit, ' products:', tagProductsId)

            d4ClearBundle();
            freeProductFunctionCalled = false;
            tagProductsId.forEach(productId => {
                const productElm = document.querySelector(`.d4-custom-bundle-container .d4-flavor-products-container .d4-flavor-product[data-product-id="${productId}"]`);
                console.log('its product:',productElm)
                if(quantityLimit === 16) {
                    window.d4UpdateBundle(productElm, productElm.getAttribute(`data-bundle-${currentTag.split(' ')[0].toLowerCase()}-quantity16`));
                    console.log('dataset 16:', productElm.getAttribute(`data-bundle-${currentTag.split(' ')[0].toLowerCase()}-quantity16`))
                } else if(quantityLimit === 24) {
                    window.d4UpdateBundle(productElm, productElm.getAttribute(`data-bundle-${currentTag.split(' ')[0].toLowerCase()}-quantity24`));
                    console.log('dataset 24:', productElm.getAttribute(`data-bundle-${currentTag.split(' ')[0].toLowerCase()}-quantity24`))
                }
            })
        }
    };



    //Function to handle Mobile btn
    const d4BundleMobile = () => {
        if(window.innerWidth <= 768) {
            const bgDiv = document.querySelector('.d4-custom-bundle-container .d4-bundle-body .d4-flavor-container .d4-flavor-products-container');
            const bundle = document.querySelector('.d4-custom-bundle-container .d4-flavor-container .d4-flavor-bundle .d4-flavor-bundle-body');
            const announcement = document.querySelector('.announcement-bar-section').offsetHeight;
            const stickyHeader = document.querySelector('.section-header').offsetHeight;
            const viewportTop = announcement + stickyHeader;
            mobileBtn.addEventListener('click', () => {
                mobileBundle.classList.add('d4-flavor-bundle-mobile-visible');
                mobileBtn.closest('.d4-bundle-mobile').classList.add('d4-flavor-mobile-hide');
                d4HandleProgress();
                bundle.style.maxHeight = `calc(${window.innerHeight}px - ${viewportTop}px - 170px)`;
                bundle.style.minHeight = `calc(${window.innerHeight}px - ${viewportTop}px - 170px)`;
                bgDiv.style.background = 'rgb(0,0,0, 0.5)';
                bgDiv.style.filter = 'brightness(0.5)';
                document.body.classList.add('overflow-hidden-tablet');
                document.body.style.overflow = 'hidden';
                bgDiv.querySelector('.d4-flavor-products').style.pointerEvents = 'none';
                bgDiv.addEventListener('click', () => {
                    mobileCloseBtn.dispatchEvent(new Event('click'));
                })
            });

            mobileCloseBtn.addEventListener('click', () => {
                mobileBundle.classList.remove('d4-flavor-bundle-mobile-visible');
                mobileBtn.closest('.d4-bundle-mobile').classList.remove('d4-flavor-mobile-hide');
                bgDiv.style.background = 'none';
                bgDiv.style.filter = 'brightness(1)';
                document.body.classList.remove('overflow-hidden-tablet');
                document.body.removeAttribute('style');
                bgDiv.querySelector('.d4-flavor-products').style.pointerEvents = 'all';
            })
        }
    };

    //Media query listener to update progress bar on mobile
    if(window.innerWidth <= 768) {
        window.addEventListener('resize', d4HandleProgress);
    }


    d4LoadbundleObject();
    if (bundleContainer.hasAttribute('data-d4-bundle-free-product')) d4LoadFreeProducts();
    d4CustomBundleObject();
    d4HandleBundleVariants();
    d4HandleFilterChanges();
    d4HandleBundle();
    d4HandleProgress();
    d4HandleCheckout();
    d4BundleMobile();
});